export default "__VITE_ASSET__Bl5T1cC7__"